import { Badge } from './Badge.js';

/**
 * A figure measured on too few users to be read as a trend. Said in the words
 * of the person reading the screen, with the reason on hover.
 */
export function LowSampleBadge({ unit = 'usagers' }: { unit?: 'usagers' | 'avis' }) {
  return (
    <span title={`Mesuré sur trop peu d'${unit} : chiffre à lire avec prudence, il peut varier fortement.`}>
      <Badge tone="warning">Peu d'{unit}</Badge>
    </span>
  );
}
